import React from 'react';
import { Cushion, ShimmerImage, ShimmerTypography } from '@pitchero/react-ui';

const NewsArticleLoadingState = () => (
  <>
    <ShimmerImage preset="headline" fullWidth />
    <Cushion top="large">
      <ShimmerTypography preset="title" />
      <ShimmerTypography preset="title" width="80%" />
    </Cushion>
    <Cushion top="medium" component="div">
      <ShimmerTypography width="30%" />
    </Cushion>
    <Cushion top="large">
      <ShimmerTypography />
      <ShimmerTypography width="70%" />
    </Cushion>
    <Cushion top="large">
      <ShimmerTypography />
      <ShimmerTypography />
      <ShimmerTypography />
      <ShimmerTypography />
      <ShimmerTypography />
      <ShimmerTypography />
      <ShimmerTypography width="60%" />
    </Cushion>
  </>
);

export default NewsArticleLoadingState;
